<template>
    <div class="home">
        <div class="profile-img">
            <img src="../assets/Profile.png" alt="">
        </div>
        <div class="name">
            <h1 class="line-1 anim-typewriter">Aaron Gabriel Fulgar</h1>
            <p>A 22-year old <strong>Web Developer</strong> from Danao City based in Cebu, Philippines</p>
        </div>
        <div class="social-links">
            <a href="https://www.facebook.com/fxz.gg" target="_blank">
                <i class="fa-brands fa-facebook"></i>
            </a>
            <a href="https://www.messenger.com/t/100006384571053" target="_blank">
                <i class="fa-brands fa-facebook-messenger"></i>
            </a>
            <a href="https://www.instagram.com/gabriel.a.gtfo/" target="_blank">
                <i class="fa-brands fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/in/aaron-gabriel-fulgar/" target="_blank">
                <i class="fa-brands fa-linkedin"></i>
            </a>
        </div>
        <div class="button-links">
            <a href="https://drive.google.com/file/d/1TIlqHWJDdklaCbksmgiQ371AyWr5zcbF/view?usp=sharing" target="_blank" class="link-1">
                Download CV
            </a>
            <router-link :to="{name: 'contact'}" id="link-trans">Let's Talk</router-link>
        </div>
        <div class="scroll-down-animate">
            <i class="fa-sharp fa-solid fa-arrow-down"></i>
        </div>
        <div class="recent-work">
            <h1>Recent Work</h1>
            <div class="projects">
                <div class="project">
                    <div class="img">
                        <img src="../assets/scheduler.png" alt="">
                    </div>
                    <div class="title">
                        <h1>Plotter Scheduler with TimeTable</h1>
                        <p>This project is also developed during my internship. This is the first task that is given to me before <strong>Online Item Requisition & Management</strong>, but suddenly stop because of the other task has been given to us and that's <strong>Online Item Requisition & Management</strong>. I know Plotter Scheduler has a big impact to view your schedule more visibility with time grid so I continue developing this project. I used <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>Javascript</strong>, <strong>jQuery</strong>, <strong>PHP</strong>, and <strong>MySQL</strong>.</p>
                        <a href="https://github.com/ronnin01/Plotter-Scheduling" target="_blank">View Code</a>
                    </div>
                </div>
                <div class="project reverse">
                    <div class="title">
                        <h1>Online Item Requisition & Management</h1>
                        <p>This system application is made during my internship in <strong>Cebu Technological University - Danao Campus</strong>. This is made to manage items in supply office and teachers items. Students, Teachers and Faculties has their own account to borrow items from a specific owner or direct to the supply items. We used <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>Javascript</strong>, <strong>jQuery</strong>, <strong>Flask</strong>, and <strong>MSSQL</strong>.</p>
                        <a type="button">Confidential</a>
                    </div>
                    <div class="img">
                        <img src="../assets/requisition.png" alt="">
                    </div>
                </div>
                <div class="project">
                    <div class="img">
                        <img src="../assets/reservation.png" alt="">
                    </div>
                    <div class="title">
                        <h1>Centrum Reservation System Management</h1>
                        <p>This system application is my Capstone Thesis Project. Basically this system is only admin panel, that only manage who are booked and reserved for a specific day. I integrated also FullCalendar for better view of reservations. I used <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>Javascript</strong>, <strong>jQuery</strong>, <strong>PHP</strong>, and <strong>MySQL</strong>.</p>
                        <a type="button">Confidential</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                
            }
        }
    }
</script>